var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cart_svg__a",
    d: "M0 0h98v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cart_svg__c",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cart_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cart_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.631.023C87.701-.012 81.77-.004 75.84.027c-2.179.011-3.558 1.027-4.31 3.065-1.512 4.104-3.033 8.205-4.482 12.332-.294.837-.63 1.13-1.546 1.13-20.25-.033-40.5-.028-60.75-.014-.648 0-1.342.046-1.937.275-2.841 1.095-3.092 3.274-2.63 5.913.363 2.085 2.071 3.151 4.514 3.151 19.16.002 38.32.001 57.48.001h1.034c-.603 1.668-1.187 3.194-1.7 4.743-.231.697-.557.95-1.335.95-17.008-.03-34.016-.029-51.024-.003-.807.001-1.685.133-2.408.47-1.94.907-2.348 2.642-2.262 4.636.106 2.47 1.819 4.213 4.282 4.222 2.208.007 4.416.008 6.625.008h42.326c-.59 1.633-1.19 3.187-1.707 4.769-.25.76-.613 1.036-1.451 1.034a10763.97 10763.97 0 0 0-38.12-.014c-.625 0-1.271.042-1.87.204-2.057.556-3.011 2.1-3 4.726.011 2.569 1.773 4.373 4.296 4.374 14.505.002 29.01.001 43.515-.003 2.055 0 3.45-.995 4.168-2.962C64.831 49.52 66.104 46 67.39 42.488c2.905-7.944 5.816-15.886 8.722-23.83 1.107-3.025 2.206-6.053 3.32-9.11 4.51 0 8.982-.016 13.454.006 3.457.017 5.158-1.656 5.115-5.1-.034-2.628-1.735-4.416-4.369-4.431",
    fill: "#FEFEFE",
    mask: "url(#cart_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cart_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cart_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.32.01C3.947-.217.197 3.306.007 7.822c-.18 4.273 3.271 7.993 7.79 8.173 4.204.167 8.09-2.98 8.2-7.892.1-4.365-3.26-7.886-7.677-8.091",
    fill: "#FEFEFE",
    mask: "url(#cart_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.035 62c-3.317.002-6.033 2.464-6.035 5.47-.002 3.06 2.714 5.544 6.047 5.53 3.311-.014 5.95-2.454 5.953-5.503.002-3.054-2.65-5.5-5.965-5.497",
    fill: "#FEFEFE"
  }))));
};

export default SvgCart;